module.exports = __webpack_public_path__ + "static/media/logo_white.8484a310.png";